import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextInputHighlightComponent } from './components/text-input-highlight.component';
import { TextInputHighlightContainerDirective } from './directive/text-input-highlight-container.directive';
import { TextInputElementDirective } from './directive/text-input-element.directive';

@NgModule({
  declarations: [
    TextInputHighlightComponent,
    TextInputHighlightContainerDirective,
    TextInputElementDirective
  ],
  imports: [CommonModule],
  exports: [
    TextInputHighlightComponent,
    TextInputHighlightContainerDirective,
    TextInputElementDirective
  ]
})
export class TextInputHighlightModule {}
